import CalculatedValues from './CalculatedValues';

export default CalculatedValues;
